var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/personal-info-macro.j2"] = require( "macros/personal-info-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/demographics-view.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/personal-info-macro.j2", false, "account/templates/partials/demographics-view.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genderLocalizationSlug")) {
var t_4 = t_1.genderLocalizationSlug;
} else {
cb(new Error("cannot import 'genderLocalizationSlug'")); return;
}
context.setVariable("genderLocalizationSlug", t_4);
if(t_1.hasOwnProperty("areYouAStudent")) {
var t_5 = t_1.areYouAStudent;
} else {
cb(new Error("cannot import 'areYouAStudent'")); return;
}
context.setVariable("areYouAStudent", t_5);
if(t_1.hasOwnProperty("showDemographicsBirthDate")) {
var t_6 = t_1.showDemographicsBirthDate;
} else {
cb(new Error("cannot import 'showDemographicsBirthDate'")); return;
}
context.setVariable("showDemographicsBirthDate", t_6);
output += "\n\n<p class=\"c-profile__p--edit\">\n\n    <section class=\"c-profile__section js-account-demographics\">\n\n        <div class=\"u-line\">\n\n            <span class=\"u-global-h5\" data-qa-account-info-birth-date>\n                ";
output += runtime.suppressValue((lineno = 11, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-birthDate"])), env.opts.autoescape);
output += ":\n            </span>\n\n            <span data-qa-saved-birth-date>\n                ";
output += runtime.suppressValue((lineno = 15, colno = 42, runtime.callWrap(t_6, "showDemographicsBirthDate", context, [])), env.opts.autoescape);
output += "\n            </span>\n\n        </div>\n\n        <div class=\"u-line\">\n\n            <span class=\"u-global-h5\" data-qa-account-info-birth-date>\n                ";
output += runtime.suppressValue((lineno = 23, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-gender"])), env.opts.autoescape);
output += ":\n            </span>\n\n            <span>\n                ";
output += runtime.suppressValue((lineno = 27, colno = 39, runtime.callWrap(t_4, "genderLocalizationSlug", context, [runtime.memberLookup(((lineno = 27, colno = 51, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"gender")])), env.opts.autoescape);
output += "\n            </span>\n\n        </div>\n\n        <div class=\"u-line\">\n\n            <span class=\"u-global-h5\" data-qa-account-info-birth-date>\n                ";
output += runtime.suppressValue((lineno = 35, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-areYouAStudent"])), env.opts.autoescape);
output += ":\n            </span>\n\n            <span>\n                ";
output += runtime.suppressValue((lineno = 39, colno = 31, runtime.callWrap(t_5, "areYouAStudent", context, [(lineno = 39, colno = 43, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))])), env.opts.autoescape);
output += "\n            </span>\n\n        </div>\n\n    </section>\n\n</p>\n\n<p class=\"c-profile__p\">\n\n    <a class=\"c-profile__link js-account-edit-profile-demographics\" data-cm-element=\"account-edit-gender\" href=\"";
output += runtime.suppressValue((lineno = 50, colno = 114, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_edit"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 51, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-edit"])), env.opts.autoescape);
output += "\n    </a>\n\n</p>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/demographics-view.j2"] , dependencies)